import React, { use, useEffect, useState } from "react";
import Switch from 'react-switch';
import { useTranslation } from "react-i18next"
import DisPlayWave from '../../../components/BedSettings/DisPlayWave';
import DisPlayNumeric from '../../../components/BedSettings/DisplayNumeric';
import {ReactComponent as IconInit} from '../../../assets/icons/ic-init.svg'
import axios from '../../../plugins/axios'
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { useRecoilState } from "recoil";
import { selectBedInfoState } from '../../../plugins/recoil';

//Bed Setting - 디스플레이 설정
function DisplaySettings({waveArr,numericArr, handleIsDisabled,handleChangeSelect, handleChangeSpeedSelect, numericCodeList,waveCodeList,vsmMode,handleVsmMode, onDragWaveEnd,onDragNumericEnd}) {
    const { t } = useTranslation()
    const [selectBedInfo, ] = useRecoilState(selectBedInfoState)

    return (
        <div className="relative flex justify-between w-full p-[20px] overflow-y-auto scrollbar" style={{ height: 'calc(100%)' }}>
            <div className="flex justify-start">
                <div className="flex flex-col flex-wrap">
                    <div className="flex items-center justify-between gap-[8px]">
                        <span className="text-white whitespace-nowrap" style={{ fontSize: 18 }}>{t('bedSetting.vsmMode')}</span>
                        <Switch
                            onChange={() => {handleVsmMode(!vsmMode); handleIsDisabled(false);}}
                            checked={vsmMode}
                            offColor="#5E5E5E"
                            onColor="#3182F7"
                            checkedIcon={false}
                            uncheckedIcon={false}
                            height={20}
                            width={36}
                            handleDiameter={18}
                        />
                    </div>
                </div>
                {
                    vsmMode ? (                        
                        <>
                            {/* VSM ON */}                            
                            <div className="flex p-[16px] mx-[20px] bg-[#2F2F2F] w-[300px] h-[386px] rounded-lg gap-[8px]">
                                <div className="flex flex-wrap w-[64px] text-white whitespace-nowrap">
                                    <div className="h-[35px] mt-[10px] font-light">{`${t('bedSetting.numeric')} 1`}</div>
                                    <div className="h-[35px] mt-[10px] font-light">{`${t('bedSetting.numeric')} 2`}</div>
                                    <div className="h-[35px] mt-[10px] font-light">{`${t('bedSetting.numeric')} 3`}</div>
                                    <div className="h-[35px] mt-[10px] font-light">{`${t('bedSetting.numeric')} 4`}</div>
                                    <div className="h-[35px] mt-[10px] font-light">{`${t('bedSetting.numeric')} 5`}</div>
                                    <div className="h-[35px] mt-[10px]">　</div>
                                </div>
                                {/* Drag & Drop */}                                                                                    
                                <div className="flex flex-col flex-wrap w-[371px]">                            
                                    <div className="relative flex flex-col justify-center w-[100%]">
                                        {
                                            numericArr.map((numeric, idx) => (
                                                <div key={`draggable-${selectBedInfo.deviceId}-${numeric.measureParameterName}-${numeric.measureParameterId}-${numeric.displayOrder}`}>
                                                    <DisPlayNumeric Numeric={numeric} index={idx} handleChangeSelect={handleChangeSelect} numericList={numericArr} numericCodeList={numericCodeList} vsmMode={vsmMode}/>
                                                </div>                                                
                                            )
                                        )}                                        
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (                        
                        <>
                            {/* VSM OFF */}
                            <div className="flex items-start flex-wrap w-[784px] mx-[20px] bg-[#2F2F2F] h-[386px] px-[16px] py-[10px] rounded-lg">  
                                <div className="flex flex-wrap w-[64px] h-[60px] gap-[8px] text-white whitespace-nowrap font-light">
                                    <p className="h-[42px] text-white mt-[10px]">{`${t('bedSetting.wave')} 1`}</p>
                                    <p className="h-[42px] text-white mt-[10px]">{`${t('bedSetting.wave')} 2`}</p>
                                    <p className="h-[42px] text-white mt-[10px]">{`${t('bedSetting.wave')} 3`}</p>
                                    <p className="h-[42px] text-white mt-[10px]">{`${t('bedSetting.wave')} 4`}</p>
                                    <p className="h-[42px] text-white mt-[10px]">{`${t('bedSetting.wave')} 5`}</p>
                                    <p className="h-[42px] text-white mt-[10px]">{`${t('bedSetting.wave')} 6`}</p>
                                </div>
                                <DragDropContext onDragEnd={onDragWaveEnd}>
                                    <Droppable droppableId="wave">
                                        {(provided) => 
                                        (
                                            <div className="flex-1" ref={provided.innerRef} {...provided.droppableProps}>
                                                {
                                                    waveArr && (                            
                                                        waveArr.map((wave,idx) => {
                                                            return <DisPlayWave key={`draggable-${selectBedInfo.deviceId}-babo-${wave.measureParameterName}-${wave.measureParameterId}-${wave.displayOrder}`} wave={wave} index={idx} handleChangeSpeedSelect={handleChangeSpeedSelect} handleChangeSelect={handleChangeSelect} waveList={waveArr} waveCodeList={waveCodeList}/>
                                                        })
                                                    )
                                                }
                                            {provided.placeholder}
                                            </div>
                                        )}                            
                                    </Droppable>
                                </DragDropContext>
                            </div>  
                            <div className="flex px-[16px] py-[10px] bg-[#2F2F2F] w-[561px] h-[386px] rounded-lg gap-[8px]">
                                <div className="flex flex-wrap w-[64px] text-white whitespace-nowrap font-light">
                                    <div className="h-[35px] mt-[10px]">{`${t('bedSetting.numeric')} 1`}</div>
                                    <div className="h-[35px] mt-[10px]">{`${t('bedSetting.numeric')} 2`}</div>
                                    <div className="h-[35px] mt-[10px]">{`${t('bedSetting.numeric')} 3`}</div>
                                    <div className="h-[35px] mt-[10px]">{`${t('bedSetting.numeric')} 4`}</div>
                                    <div className="h-[35px] mt-[10px]">{`${t('bedSetting.numeric')} 5`}</div>
                                    <div className="h-[35px] mt-[10px]">{`${t('bedSetting.numeric')} 6`}</div>
                                </div>
                                {/* Drag & Drop */}                    
                                <DragDropContext onDragEnd={onDragNumericEnd}>
                                    <div className="flex justify-center flex-col flex-wrap w-[371px]">                            
                                        <Droppable droppableId="left">
                                            {(provided) => (
                                                <div className="relative flex flex-col justify-center w-[50%]" ref={provided.innerRef} {...provided.droppableProps}>
                                                    {numericArr.slice(0, 6).map((numeric, idx) => (
                                                        <Draggable key={`draggable-${selectBedInfo.deviceId}-${numeric.measureParameterName}-${numeric.measureParameterId}-${numeric.displayOrder}`} draggableId={`draggable-${numeric.measureParameterId}-${numeric.displayOrder}`} index={idx}>
                                                            {(provided) => (
                                                                <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                                    <DisPlayNumeric Numeric={numeric} index={idx} handleChangeSelect={handleChangeSelect} numericList={numericArr} numericCodeList={numericCodeList} vsmMode={vsmMode}/>
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                        
                                        <Droppable droppableId="right">
                                            {(provided) => (
                                                <div className="relative flex flex-col justify-center w-[50%]" ref={provided.innerRef} {...provided.droppableProps}>
                                                    {numericArr.slice(6, 12).map((numeric, idx) => (
                                                        <Draggable key={`draggable-${selectBedInfo.deviceId}-${numeric.measureParameterName}-${numeric.measureParameterId}-${numeric.displayOrder}`} draggableId={`draggable-${numeric.measureParameterId}-${numeric.displayOrder}`} index={idx + 6}>
                                                            {(provided) => (
                                                                <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                                    <DisPlayNumeric Numeric={numeric} index={idx + 6} handleChangeSelect={handleChangeSelect} numericList={numericArr} numericCodeList={numericCodeList} vsmMode={vsmMode}/>
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                    </div>
                                </DragDropContext>
                                <div className="flex flex-wrap w-[64px] text-white whitespace-nowrap font-light">
                                    <div className="h-[35px] mt-[10px]">{`${t('bedSetting.numeric')} 7`}</div>
                                    <div className="h-[35px] mt-[10px]">{`${t('bedSetting.numeric')} 8`}</div>
                                    <div className="h-[35px] mt-[10px]">{`${t('bedSetting.numeric')} 9`}</div>
                                    <div className="h-[35px] mt-[10px]">{`${t('bedSetting.numeric')} 10`}</div>
                                    <div className="h-[35px] mt-[10px]">{`${t('bedSetting.numeric')} 11`}</div>
                                    <div className="h-[35px] mt-[10px]">{`${t('bedSetting.numeric')} 12`}</div>
                                </div>
                            </div>
                        </>
                    )
                }
            </div>
            
        </div>
    );
}

export default DisplaySettings;
